import api from '../../../api';
import helpers from '../../../services/helpers';

export default {
  setTickets({ commit, getters, dispatch }, data) {
    dispatch('resetTicketHistoryState');
    const { headersSettings } = getters;

    const options = {
      headers: helpers.formatHeaders(headersSettings),
      params: {
        ...data,
        deviceUuid: headersSettings.deviceUuid,
      },
    };

    const settings = {
      cpvUuid: headersSettings.cpvUuid,
      companyUuid: headersSettings.companyUuid,
    };

    api.loadTicketList(settings, options).then((response) => {
      commit('SET_TICKET_LIST', response.data);
    }).catch(err => console.log(err));
  },
  setHeadersSettings({ commit }, data) {
    commit('SET_HEADERS_SETTINGS', data);
  },
  resetTicketHistoryState({ commit }) {
    commit('RESET_TICKET_HISTORY_STATE');
  },
};
